import { useTranslations } from "use-intl";

import { EDITORIAL_HUB_FAMILIES } from "@/features/editorial-hub/editorial-hub-families";
import { EditorialHubFamilyCard } from "@/features/editorial-hub/editorial-hub-family-card";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function EditorialHubContent({ locale }: { locale: ViewerLocale }) {
  const t = useTranslations("editorialHub");

  return (
    <section
      aria-labelledby="editorial-hub-title"
      className="relative isolate overflow-hidden px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20"
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[34rem] bg-[radial-gradient(circle_at_top_left,hsl(var(--primary)/0.18),transparent_56%)]" />
      <div className="pointer-events-none absolute right-0 top-48 -z-10 size-96 rounded-full bg-primary/5 blur-3xl" />

      <div className="mx-auto max-w-[1440px]">
        <header className="max-w-5xl">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-primary">
            {t("eyebrow")}
          </p>
          <h1
            id="editorial-hub-title"
            className="mt-3 text-balance text-5xl font-black tracking-tight sm:text-6xl lg:text-7xl"
          >
            {t("title")}
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            {t("description")}
          </p>
        </header>

        <ul className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {EDITORIAL_HUB_FAMILIES.map((family) => (
            <li key={family}>
              <EditorialHubFamilyCard family={family} locale={locale} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
